import FormattedMessage from 'I18n/components/FormattedMessage';
import Products from 'merchandise-lib/constants/Product';
import { HubMerchCardLayoutUI } from '../../containers/merch-card/HubMerchCardLayoutUI';
import { StarterLowerTierMessage } from '../../containers/merch-card/StarterLowerTierMessage';
import { useIsFreePortal } from '../../hooks/inventory/useProductInventory';
import { jsx as _jsx } from "react/jsx-runtime";
export const MarketingHubMerchCards = () => {
  const {
    isFreePortal,
    loading
  } = useIsFreePortal();
  const productsConfig = {
    STARTER: {
      apiName: Products.MARKETING_HUB_STARTER,
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.marketing.starterCard.description"
      }),
      lowerTierMessage: StarterLowerTierMessage({
        isFreePortal,
        loading
      })
    },
    PROFESSIONAL: {
      apiName: Products.MARKETING_HUB_PROFESSIONAL,
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.marketing.professionalCard.description"
      }),
      lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.marketing.professional.lowerTierPlus"
      })
    },
    ENTERPRISE: {
      apiName: Products.MARKETING_HUB_ENTERPRISE,
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.marketing.enterpriseCard.description"
      }),
      lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.marketing.enterprise.lowerTierPlus"
      })
    }
  };
  return /*#__PURE__*/_jsx(HubMerchCardLayoutUI, {
    productsConfig: productsConfig
  });
};